import type { ServiceCharge } from 'api/serviceCharges'
import { buildTranslate } from 'locales'
import numeral from 'numeral'

const t = buildTranslate(
  'locations.location_list.location_detail.service_charges'
)

export const formatServiceChargeAmount = (
  charge: Pick<ServiceCharge, 'amount_type' | 'amount_value'>
): string => {
  switch (charge.amount_type) {
    case 'PERCENT':
      return numeral(charge.amount_value / 100).format('0.[00]%')
    case 'FIXED':
      return numeral(charge.amount_value).format('$0,0.00')
    case 'OPEN':
      return t('amount_varies')
  }
}
